import { AllStats, QuestionAnswerCount } from "../../../domain/model/Stats";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { StatsRepository } from "./StatsRepository";

export class StatsRepositoryImpl implements StatsRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getAllStats(): Promise<Response<AllStats>> {
    return this.apiService.getAllStats();
  }
  getQuestionsAndAnswersStats(): Promise<Response<QuestionAnswerCount>> {
    return this.apiService.getQuestionsAndAnswersStats();
  }
}
